module.exports = __webpack_public_path__ + "img/twitter.4d511dec.svg";